import RecordsModule from './index.vue';

// eslint-disable-next-line import/prefer-default-export
export const recordsRoutes = [
  {
    path: '/records',
    component: RecordsModule,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'Records',
        component: () => import(/* webpackChunkName: "users" */ './pages/record-list.vue'),
        meta: {
          /** Access to this route is managed on the server no need to specify in the meta */
        },
      },
    ],
  },
];
